import { render, staticRenderFns } from "./GapManagement.vue?vue&type=template&id=06e8fea0&scoped=true"
import script from "./GapManagement.vue?vue&type=script&lang=js"
export * from "./GapManagement.vue?vue&type=script&lang=js"
import style0 from "./GapManagement.vue?vue&type=style&index=0&id=06e8fea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e8fea0",
  null
  
)

export default component.exports